import * as React from 'react'
import * as PropTypes from 'prop-types'
import { Redirect } from 'react-router'
import styled from 'styled-components'

import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'
import Layout from '../../../../components/ui/Layout/Layout'
import DisplayPhotoForm from '../../../../components/home/DisplayPhotoForm/DisplayPhotoForm'

import {
  LANDING,
  AVATAR,
  // ADD_CARD,
  PREFERENCES,
} from '../../../../services/data/registrationSteps.json'
import {
  STEP_DEFAULT,
  STEP_UPLOAD,
  STEP_CROPPED,
} from '../../../../services/data/uploadAvatarSteps.json'
import media from '../../../../services/generateMediaQueries'

import {
  doUploadAvatar,
  doHandleSSORedirection,
} from '../../../../controllers/Registration'
import validateDisplayPhoto from '../../../../services/validation/DisplayPhoto'
import { setGAPageView } from '../../../../services/analytics/google-analytics'

import SkipAddAvatarForm from '../SkipAddAvatarForm/SkipAddAvatarForm'
import { postDevices } from '../../../../services/api/requests/Device'
// import { decodeSSOData, getSSOToken } from '../../../../services/data/sso'

const Title = styled.h1`
  font-size: 1.5rem;
  text-align: center;
  margin-top: 0;
  font-weight: var(--font-weight-boldest);
  color: var(--color-secondary);
`

const Description = styled.p`
  text-align: center;
`

const FormWrapper = styled.div`
  margin: 2.5rem 0 0;
  ${media.lessThan('small')`
    margin: 1.5rem 0 0;
  `}
`

// const dropOffEvent = () => {
// setGAEvent('sign_up', 'sign_up_drop_off', 'registration_selfie')
// }

function MainView({
  accessToken,
  step,
  primaryInfo,
  setStep,
  setPrimaryInfo,
  push,
  browser,
  setDevice,
  redirectAfterAuth,
  saveAccessToken,
  location = {},
}) {
  const [avatarState, setAvatarState] = React.useState(STEP_DEFAULT)

  React.useEffect(() => {
    if (location) setGAPageView(location.pathname)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  React.useEffect(() => {
    if (window.document.cookie.includes('web_uuid=')) {
      return
    }
    const { name, os, version } = browser
    postDevices({
      platform: 'web',
      deviceName: name,
      deviceModel: os,
      osVersion: version,
    }).then(res => {
      setDevice(res.data)
    })
  }, [browser, setDevice])

  const redirectToThirdParty = (redirectUri, code) => {
    if (typeof window !== undefined && window.location && redirectUri) {
      window.location.href = redirectUri + (code ? `?code=${code}` : '')
    }
  }

  const skip = React.useCallback(async () => {
    await saveAccessToken(accessToken)

    //sso redirection
    // const token = await getSSOToken()
    // const { code } = await decodeSSOData(token)
    await doHandleSSORedirection(
      location.search,
      redirectToThirdParty,
      accessToken,
      async () => {
        setStep(PREFERENCES)
        await push(redirectAfterAuth || '/')
      },
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setStep, push, saveAccessToken, accessToken, redirectAfterAuth])

  if (step !== AVATAR) {
    return <Redirect to={`/register${location.search || ''}`} />
  }

  if (primaryInfo === null) {
    return <Redirect to="/" />
  }

  const { avatarUrl } = primaryInfo || {}

  return (
    <Layout>
      {avatarState === STEP_DEFAULT && (
        <>
          <Title>Upload photo</Title>
          <Description>Make Zing personal by adding your photo.</Description>
        </>
      )}
      <FormWrapper>
        <AccessibleForm
          initialValues={{
            avatarUrl,
          }}
          isInitialValid={!!avatarUrl}
          validate={validateDisplayPhoto}
          onSubmit={doUploadAvatar({
            setStep,
            push,
            accessToken,
            saveAccessToken,
            setPrimaryInfo,
            redirectAfterAuth,
            redirectToThirdParty,
            searchString: location.search,
          })}
          component={DisplayPhotoForm}
          componentProps={{
            onAvatarUpload: () => setAvatarState(STEP_UPLOAD),
            onAvatarCrop: () => setAvatarState(STEP_CROPPED),
            showSubmitButton: avatarState === STEP_CROPPED,
            showUploadLabel: avatarState !== STEP_DEFAULT,
            showDefaultAvatar: false,
          }}
          action="/a/avatar"
          method="post"
        />
        {avatarState !== STEP_UPLOAD && (
          <AccessibleForm
            action="/a/avatar"
            method="post"
            initialValues={{}}
            onSubmit={skip}
            component={SkipAddAvatarForm}
          />
        )}
      </FormWrapper>
    </Layout>
  )
}

MainView.defaultProps = {
  step: LANDING,
  primaryInfo: null,
}

MainView.propTypes = {
  accessToken: PropTypes.string.isRequired,
  step: PropTypes.number,
  primaryInfo: PropTypes.shape(),
  setStep: PropTypes.func.isRequired,
  setPrimaryInfo: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
}

export default MainView
